import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';

export const AnalyzeYourExpensesAnswerResultTemplate = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <PXTextModalWrapper resource={resource} primaryButtonLabel={'Continue →'}>
      <MetaControlField attr={'content'} />
    </PXTextModalWrapper>
  );
};

AnalyzeYourExpensesAnswerResultTemplate.defaultProps = {
};

AnalyzeYourExpensesAnswerResultTemplate.propTypes = {
};
